import { Link } from 'react-router-dom';

export function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-[#0B0F10] text-white">
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 text-[#A9B4B8] hover:text-[#2EC4B6] transition-colors">
            <img src="/eventtools-logo.svg" alt="Event.Tools" className="w-10 h-10 object-contain" />
            <span className="font-display font-bold text-lg text-white">Event.Tools</span>
          </Link>
          <Link to="/" className="text-sm text-[#A9B4B8] hover:text-white transition-colors">Back to home</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-display font-bold text-3xl md:text-4xl text-white mb-2">Privacy Policy</h1>
        <p className="text-[#A9B4B8] text-sm mb-10">Last updated: February 2025</p>

        <div className="prose prose-invert prose-sm max-w-none space-y-8 text-[#A9B4B8] leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">1. Who we are</h2>
            <p>Event.Tools (“we,” “us”) operates the website event.tools and the Event.Tools Flyer Builder application. This policy describes how we collect, use, and protect information when you use our Service.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">2. Information we collect</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-white">Account and identity:</strong> If you sign in (e.g. via email or Google), we receive identifiers such as email address and name from the provider.</li>
              <li><strong className="text-white">Content you provide:</strong> Assets you upload (logos, photos, flyers), project data, event and calendar information, and prompts or text you enter to generate content.</li>
              <li><strong className="text-white">Usage and technical data:</strong> Logs, device/browser information, and usage patterns to operate and improve the Service.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">3. How we use it</h2>
            <p>We use this information to provide, secure, and improve the Service; to fulfill your requests (e.g. generating flyers, syncing calendars); to communicate with you; and to comply with legal obligations. We may use third-party services (e.g. cloud hosting, AI providers) that process data on our behalf under contractual safeguards.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">4. AI and third-party providers</h2>
            <p>Features such as AI-generated imagery may send prompts and related content to external AI providers. We choose providers that commit to appropriate data handling; their terms and privacy practices apply to that processing. We do not sell your personal information.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">5. Data retention and your choices</h2>
            <p>We retain your data as long as your account is active or as needed to provide the Service and comply with law. You can request access, correction, or deletion of your data by contacting us. In the desktop app, data is stored locally; account and cloud-backed data are subject to our systems and this policy.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">6. Security</h2>
            <p>We use reasonable technical and organizational measures to protect your data. No system is completely secure; we cannot guarantee absolute security.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">7. Children</h2>
            <p>The Service is not directed at children under 13. We do not knowingly collect personal information from children under 13.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">8. Changes</h2>
            <p>We may update this Privacy Policy from time to time. We will post the updated policy on the site and update the “Last updated” date. Continued use after changes constitutes acceptance.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">9. Contact</h2>
            <p>For privacy-related questions or requests, contact us at <a href="mailto:hello@event.tools" className="text-[#2EC4B6] hover:underline">hello@event.tools</a>.</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <Link to="/" className="text-[#2EC4B6] hover:underline text-sm">← Back to Event.Tools</Link>
        </div>
      </main>
    </div>
  );
}
